import { render, staticRenderFns } from "./header.vue?vue&type=template&id=52491c2f&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"
import style0 from "./header.vue?vue&type=style&index=0&id=52491c2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52491c2f",
  null
  
)

export default component.exports